'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
var classNames = require('classnames');
var context = require('@andes/context');
var common = require('@andes/common');
require('@andes/common/build/utils/includes');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var keyboardCodes = require('@andes/common/build/constants/keyboardCodes');
var popper = require('@andes/popper');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _jsx__default = /*#__PURE__*/_interopDefaultLegacy(_jsx);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
const ICON_OPACITY_LOW = '0.25';
const ICON_OPACITY_MID = '0.45';
const ICON_OPACITY_HIGH = '1';
const ICON_SIZE_SMALL = '12';
const ICON_SIZE_LARGE = '16';
const CloseIcon = _ref => {
  let {
    namespace,
    size,
    opacity = ICON_OPACITY_HIGH
  } = _ref;
  return /*#__PURE__*/_jsx__default["default"]("svg", {
    className: "".concat(namespace, "__close-icon ").concat(namespace, "__svg-fill"),
    width: size,
    height: size,
    viewBox: "0 0 16 16"
  }, void 0, /*#__PURE__*/_jsx__default["default"]("path", {
    transform: "translate(3 3)",
    fillOpacity: opacity,
    d: "M8.594.552l.855.842L5.87 5.022 9.45 8.6l-.849.848-3.572-3.572-3.521 3.572-.855-.842L4.18 5.028.552 1.4l.849-.848 3.621 3.62L8.594.553z"
  }));
};
var CloseIcon$1 = CloseIcon;
const CheckIcon = _ref => {
  let {
    namespace,
    size,
    opacity = ICON_OPACITY_HIGH
  } = _ref;
  return /*#__PURE__*/_jsx__default["default"]("svg", {
    width: size,
    height: size,
    viewBox: "0 0 16 16"
  }, void 0, /*#__PURE__*/_jsx__default["default"]("path", {
    className: "".concat(namespace, "__svg-fill"),
    fillRule: "nonzero",
    fillOpacity: opacity,
    d: "M6.788 9.396l4.577-4.577 1.028 1.029-5.605 5.605-3.181-3.181 1.028-1.029z"
  }));
};
var CheckIcon$1 = CheckIcon;
var module$3 = "@andes/tag";
var locale$2 = "en-US";
var translations$2 = {
  "andes-tag\u0004quitar {0}": [null, "remove {0}"],
  "andes-tag\u0004error": [null, "error"],
  "andes-tag\u0004deshabilitado": [null, "disabled"],
  "andes-tag\u0004mostrar {0} mas": [null, "show {0} more"]
};
var enTranslations = {
  module: module$3,
  locale: locale$2,
  translations: translations$2
};
var module$2 = "@andes/tag";
var locale$1 = "es-AR";
var translations$1 = {
  "andes-tag\u0004quitar {0}": [null, "quitar {0}"],
  "andes-tag\u0004error": [null, "error"],
  "andes-tag\u0004deshabilitado": [null, "deshabilitado"],
  "andes-tag\u0004mostrar {0} mas": [null, "mostrar {0} más"]
};
var esTranslations = {
  module: module$2,
  locale: locale$1,
  translations: translations$1
};
var module$1 = "@andes/tag";
var locale = "pt-BR";
var translations = {
  "andes-tag\u0004quitar {0}": [null, "tirar {0}"],
  "andes-tag\u0004error": [null, "erro"],
  "andes-tag\u0004deshabilitado": [null, "desativado"],
  "andes-tag\u0004mostrar {0} mas": [null, "mostrar mais {0}"]
};
var ptTranslations = {
  module: module$1,
  locale: locale,
  translations: translations
};
const DEPRECATED_COLOR_DEFAULT = 'default';
const DEPRECATED_COLOR_SUCCESS = 'success';
const DEPRECATED_COLOR_ERROR = 'error';
const DEPRECATED_COLOR_WARNING = 'warning';
const COLOR_GREEN = 'green';
const COLOR_RED = 'red';
const COLOR_ORANGE = 'orange';
const namespace = 'andes-tag';
const namespaceCollapsed = "".concat(namespace, "-collapsed");
const computeColor = color => {
  switch (color) {
    case DEPRECATED_COLOR_DEFAULT:
      return undefined;
    case DEPRECATED_COLOR_ERROR:
      return COLOR_RED;
    case DEPRECATED_COLOR_WARNING:
      return COLOR_ORANGE;
    case DEPRECATED_COLOR_SUCCESS:
      return COLOR_GREEN;
    default:
      return color;
  }
};
var computeColor$1 = computeColor;
const Asset = _ref => {
  let {
    asset,
    label
  } = _ref;
  const [imageError, changeImageError] = React.useState(false);
  const [landscapeImage, changeLandscapeImage] = React.useState(false);
  const [imageLoaded, changeImageLoaded] = React.useState(false);
  const onImageError = () => {
    changeImageError(true);
  };
  const onImageLoad = event => {
    const {
      naturalWidth,
      naturalHeight
    } = event.target;
    changeLandscapeImage(naturalWidth > naturalHeight);
    changeImageLoaded(true);
  };
  if (!asset) return null;
  const hasImageAsset = asset.imageUrl && !imageError;
  const imageClassName = hasImageAsset ? classNames__default["default"]("".concat(namespace, "__avatar-image"), {
    ["".concat(namespace, "__avatar-image--landscape")]: landscapeImage,
    ["".concat(namespace, "__avatar-image--loaded")]: imageLoaded
  }) : undefined;
  return /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(namespace, "__avatar")
  }, void 0, hasImageAsset && /*#__PURE__*/_jsx__default["default"]("img", {
    onError: onImageError,
    className: imageClassName,
    onLoad: onImageLoad,
    src: asset.imageUrl,
    alt: label
  }), !hasImageAsset && asset.icon && /*#__PURE__*/_jsx__default["default"]("div", {
    "aria-hidden": true,
    className: "".concat(namespace, "__avatar-icon-container")
  }, void 0, asset.icon), !hasImageAsset && !asset.icon && asset.text && /*#__PURE__*/_jsx__default["default"]("div", {
    className: "".concat(namespace, "__avatar-text-container")
  }, void 0, asset.text));
};
var Asset$1 = Asset;
const Tag = /*#__PURE__*/function () {
  const Tag = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    var _VisuallyHidden;
    let {
      asset,
      avatar,
      children,
      className,
      clickable = false,
      closeButtonLabel,
      closeButtonSrLabel,
      color,
      component,
      disabled = false,
      error,
      id,
      label,
      onClick,
      onClose,
      selected,
      size = 'large',
      srLabel
    } = _ref;
    const componentId = context.useId(id);
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    const computedAsset = asset || avatar;
    const computedColor = computeColor$1(color);
    const handleClose = event => {
      event.stopPropagation();
      if (!disabled && typeof onClose === 'function') onClose(event);
    };
    const getIconOpacity = () => {
      if (disabled) return ICON_OPACITY_LOW;
      if (!computedColor) return ICON_OPACITY_MID;
      return ICON_OPACITY_HIGH;
    };
    const getClose = () => /*#__PURE__*/_jsx__default["default"]("button", {
      type: "button",
      className: "".concat(namespace, "__close"),
      onClick: handleClose,
      disabled: disabled,
      "aria-label": closeButtonSrLabel || closeButtonLabel || i18n.pgettext(namespace, 'quitar {0}', label)
    }, void 0, /*#__PURE__*/_jsx__default["default"]("span", {
      "aria-hidden": true,
      className: "".concat(namespace, "__icon-container")
    }, void 0, /*#__PURE__*/_jsx__default["default"](CloseIcon$1, {
      namespace: namespace,
      size: size === 'large' ? ICON_SIZE_LARGE : ICON_SIZE_SMALL,
      opacity: getIconOpacity()
    })));
    const getCheck = () => /*#__PURE__*/_jsx__default["default"]("span", {
      "aria-hidden": true,
      className: "".concat(namespace, "__icon-container")
    }, void 0, /*#__PURE__*/_jsx__default["default"](CheckIcon$1, {
      namespace: namespace,
      size: size === 'large' ? ICON_SIZE_LARGE : ICON_SIZE_SMALL,
      opacity: getIconOpacity()
    }));
    const tagClassName = classNames__default["default"](namespace, className, {
      ["".concat(namespace, "--").concat(size)]: size,
      ["".concat(namespace, "__color--").concat(computedColor)]: computedColor,
      ["".concat(namespace, "--disabled")]: disabled,
      ["".concat(namespace, "--clickable")]: (typeof onClick === 'function' || clickable) && !disabled,
      ["".concat(namespace, "--selected")]: selected
    });
    const messageError = () => error && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, i18n.pgettext(namespace, 'error'), ":");
    const messageDisabled = () => disabled && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, i18n.pgettext(namespace, 'deshabilitado'), ":");
    const screenReaderLabel = () => srLabel && (_VisuallyHidden || (_VisuallyHidden = /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, srLabel)));
    const content = children ? /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__child")
    }, void 0, messageError(), messageDisabled(), screenReaderLabel(), children) : /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__label")
    }, void 0, messageError(), messageDisabled(), screenReaderLabel(), label);
    let tagProps;
    let Component;
    if (typeof onClick === 'function' && !disabled) {
      tagProps = {
        className: tagClassName,
        onClick,
        type: 'button',
        'aria-pressed': !!selected
      };
      Component = component || 'button';
    } else {
      tagProps = {
        className: tagClassName
      };
      Component = component || 'div';
    }
    return /*#__PURE__*/React__default["default"].createElement(Component, _extends__default["default"]({}, tagProps, {
      ref: ref,
      id: componentId
    }), /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, computedAsset && size === 'large' && /*#__PURE__*/_jsx__default["default"](Asset$1, {
      asset: computedAsset,
      label: label
    }), content, selected && getCheck(), typeof onClose === 'function' && getClose()));
  });
  Tag.displayName = 'Tag';
  return Tag;
}();
var Tag$1 = Tag;
class TagCollapsed extends React__default["default"].Component {
  constructor(props) {
    super(props);
    _defineProperty__default["default"](this, "getKeyByIndex", index => {
      const {
        id
      } = this.props;
      return "".concat(id, "-item-").concat(index);
    });
    this.state = {
      moreTagsVisible: false
    };
    this.buttonRef = /*#__PURE__*/React__default["default"].createRef();
    this.showMoreTags = this.showMoreTags.bind(this);
    this.hideMoreTags = this.hideMoreTags.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
  }
  getVisibleTags(tags) {
    const {
      limit = 2
    } = this.props;
    return tags.slice(0, limit);
  }
  getEllipseTag(tags) {
    var _tags$;
    const {
      limit = 2,
      disabled = false,
      i18n
    } = this.props;
    const {
      moreTagsVisible
    } = this.state;
    const size = ((_tags$ = tags[0]) === null || _tags$ === void 0 || (_tags$ = _tags$.props) === null || _tags$ === void 0 ? void 0 : _tags$.size) || 'large';
    const label = "+".concat(tags.length - limit);
    const buttonTagClassName = classNames__default["default"](namespace, "".concat(namespace, "--").concat(size), {
      ["".concat(namespace, "--selectable")]: !disabled,
      ["".concat(namespace, "--clickable")]: !disabled,
      ["".concat(namespace, "--disabled")]: disabled
    });
    const popperOptions = {
      modifiers: [{
        name: 'offset',
        options: {
          offset: [0, 6]
        }
      }]
    };
    const listItemTagClassName = classNames__default["default"]("".concat(namespaceCollapsed, "__wrap"), "".concat(namespaceCollapsed, "__list-item"));
    return /*#__PURE__*/_jsx__default["default"]("li", {
      className: listItemTagClassName,
      onKeyDown: this.onKeyDown
    }, void 0, /*#__PURE__*/_jsx__default["default"](popper.Popper, {
      interactive: true,
      placement: "bottom-start",
      trigger: "click",
      visible: moreTagsVisible,
      popperOptions: popperOptions,
      onClickOutside: this.hideMoreTags,
      zIndex: 10000,
      content: /*#__PURE__*/_jsx__default["default"]("div", {
        className: "".concat(namespaceCollapsed, "__more"),
        role: "dialog",
        onBlur: this.onBlur
      }, void 0, /*#__PURE__*/_jsx__default["default"]("ul", {
        className: "".concat(namespaceCollapsed, "__list")
      }, void 0, tags.slice(limit).map((tag, index) => /*#__PURE__*/_jsx__default["default"]("li", {
        className: "".concat(namespaceCollapsed, "__list-item")
      }, this.getKeyByIndex(index), tag)))),
      focusScope: true
    }, void 0, /*#__PURE__*/React__default["default"].createElement("button", {
      onClick: moreTagsVisible ? this.hideMoreTags : this.showMoreTags,
      "aria-haspopup": "dialog",
      "aria-expanded": moreTagsVisible,
      "aria-label": i18n.pgettext(namespace, 'mostrar {0} mas', tags.length - limit),
      className: buttonTagClassName,
      ref: this.buttonRef,
      disabled: disabled,
      type: "button"
    }, /*#__PURE__*/_jsx__default["default"]("span", {
      className: "".concat(namespace, "__label")
    }, void 0, label))));
  }
  showMoreTags() {
    const {
      disabled = false
    } = this.props;
    if (disabled) return;
    this.setState({
      moreTagsVisible: true
    });
  }
  hideMoreTags() {
    this.setState({
      moreTagsVisible: false
    });
  }
  focusInCurrentTarget(event) {
    const {
      relatedTarget,
      currentTarget
    } = event;
    if (relatedTarget === null) return false;
    let target = relatedTarget.parentNode;
    while (target !== null) {
      if (target === currentTarget) return true;
      target = target.parentNode;
    }
    return false;
  }
  onBlur(event) {
    if (!this.focusInCurrentTarget(event)) {
      this.hideMoreTags();
    }
  }
  onKeyDown(event) {
    var _this$buttonRef;
    const {
      code
    } = event;
    const button = (_this$buttonRef = this.buttonRef) === null || _this$buttonRef === void 0 ? void 0 : _this$buttonRef.current;
    if (code === keyboardCodes.ESCAPE && button) {
      this.hideMoreTags();
      button.focus();
    }
  }
  render() {
    const {
      children,
      limit = 2,
      'aria-label': ariaLabel,
      srLabel,
      innerRef
    } = this.props;
    const collapsedTagClass = classNames__default["default"]("".concat(namespaceCollapsed), "".concat(namespaceCollapsed, "__list"), "".concat(namespaceCollapsed, "__list-main"));
    const tagChildren = React__default["default"].Children.toArray(children);
    const exceedLimit = tagChildren.length > limit;
    return /*#__PURE__*/React__default["default"].createElement("ul", {
      className: collapsedTagClass,
      "aria-label": srLabel || ariaLabel,
      ref: innerRef
    }, this.getVisibleTags(tagChildren).map((tag, index) => /*#__PURE__*/_jsx__default["default"]("li", {
      className: "".concat(namespaceCollapsed, "__list-item")
    }, this.getKeyByIndex(index), tag)), exceedLimit && this.getEllipseTag(tagChildren));
  }
}
TagCollapsed.displayName = 'TagCollapsed';
var TagCollapsed$1 = TagCollapsed;
const TagCollapsedContainer = /*#__PURE__*/function () {
  const TagCollapsedContainer = /*#__PURE__*/React.forwardRef((props, ref) => {
    const componentId = context.useId(props.id);
    const i18n = context.getPatchedI18n(context.AndesContext, enTranslations, esTranslations, ptTranslations);
    return /*#__PURE__*/React__default["default"].createElement(TagCollapsed$1, _extends__default["default"]({}, props, {
      id: componentId,
      i18n: i18n,
      innerRef: ref
    }));
  });
  TagCollapsedContainer.displayName = 'TagCollapsedContainer';
  return TagCollapsedContainer;
}();
var TagCollapsedContainer$1 = TagCollapsedContainer;
const TagChoice = /*#__PURE__*/function () {
  const TagChoice = /*#__PURE__*/React.forwardRef((_ref, ref) => {
    let {
      asset,
      className,
      defaultSelected,
      id,
      label,
      onClick,
      selected,
      size = 'large',
      srLabel
    } = _ref;
    const componentId = context.useId(id);
    const isUncontrolled = React.useMemo(() => selected === undefined, []);
    const [uncontrolledSelected, setUncontrolledSelected] = React.useState(defaultSelected);
    const isSelected = () => {
      if (isUncontrolled) return uncontrolledSelected;
      return selected;
    };
    const handleClick = event => {
      if (isUncontrolled) {
        setUncontrolledSelected(state => !state);
      }
      if (typeof onClick === 'function') onClick(event, !isSelected());
    };
    const tagClassName = classNames__default["default"](namespace, className, "".concat(namespace, "--clickable"), {
      ["".concat(namespace, "--").concat(size)]: size,
      ["".concat(namespace, "--selected")]: isSelected()
    });
    return /*#__PURE__*/React__default["default"].createElement("button", {
      className: tagClassName,
      ref: ref,
      id: componentId,
      onClick: handleClick,
      "aria-pressed": isSelected(),
      type: "button"
    }, asset && size === 'large' && /*#__PURE__*/_jsx__default["default"](Asset$1, {
      asset: asset,
      label: label
    }), /*#__PURE__*/_jsx__default["default"]("div", {
      className: "".concat(namespace, "__label")
    }, void 0, srLabel && /*#__PURE__*/_jsx__default["default"](common.VisuallyHidden, {}, void 0, srLabel), label), isSelected() && /*#__PURE__*/_jsx__default["default"]("span", {
      "aria-hidden": true,
      className: "".concat(namespace, "__icon-container")
    }, void 0, /*#__PURE__*/_jsx__default["default"](CheckIcon$1, {
      namespace: namespace,
      size: size === 'large' ? ICON_SIZE_LARGE : ICON_SIZE_SMALL
    })));
  });
  TagChoice.displayName = 'TagChoice';
  return TagChoice;
}();
var TagChoice$1 = TagChoice;
exports.Tag = Tag$1;
exports.TagChoice = TagChoice$1;
exports.TagCollapsed = TagCollapsedContainer$1;
exports["default"] = Tag$1;
